import styled from 'styled-components'
import { Button } from '~/components/shared'

export const Container = styled.div`
  position: relative;
  width: 100%;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`

export const CompareUrineCulture = styled(Button).attrs(() => ({
  variant: 'outlined',
  color: 'primary',
  width: '165px',
  children: 'Comparar Uroculturas',
  style: { padding: 0 }
}))`
  svg {
    margin-right: 8px;
    fill: ${props => props.theme.colors.color378ff7};
  }

  &:hover svg {
    fill: ${({ theme }) => theme.zds.colors.neutral1000};
  }
  &:disabled {
    cursor: not-allowed;
  }
`
